import { paymentGroupInstanceTypes } from "../PaymentGroupModel";
import { PaymentEditorModel } from "../editor/PaymentEditorModel";
import "./paymentsList.less";

class PaymentsListController {
    $onChanges(changed) {
        if (changed.paymentGroup) {
            if (this.paymentGroup != null) {
                this.foo = null;
            } else {
                this.foo = null;
            }
        }
    }

    $onDestroy() {
        this.closeEdit();
    }

    isLocked() {
        return this.paymentLock != null && this.paymentLock.isLocked;
    }

    closeEdit() {
        if (this.editing != null) {
            this.editing = null;
            this.paymentLock.reset();
        }
    }

    canSelect() {
        switch (this.paymentGroup.paymentGroupInstanceType) {
            case paymentGroupInstanceTypes.proposedClaim:
            case paymentGroupInstanceTypes.proposedTime:
                return false;
            default:
                return this.canEdit();
        }
    }

    canEdit() {
        return this.paymentGroup != null && !this.paymentGroup.certPending && !this.paymentGroup.certCertified;
    }

    editPayment(paymentModel) {
        this.editing = PaymentEditorModel.createExisting(this.paymentLock, paymentModel);
    }

    isEditingPayment(paymentModel) {
        return this.editing != null && this.editing.original === paymentModel;
    }
}

angular.module("tromanWeb").component('ergoPaymentsList', {
    template: require('./paymentsList.html'),
    bindings: {
        paymentGroup: '<',
        paymentLock: '<',
        wageTypes: '<',
    },
    controller: PaymentsListController,
});
